import "@jetbrains/ring-ui-built/components/style.css";
import { StrictMode, useLayoutEffect, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App.tsx";
import "./index.css";
import { applyTheme, Theme, ThemeProvider } from "./ui/ring.ts";

/**
 * Ring's theme classes go on <html>, following prefers-color-scheme like our own
 * tokens: Dialog portals to <body> and the alert service has its own React root,
 * so a wrapper div (what ThemeProvider alone gives) would leave them light.
 */
function RingTheme({ children }: { children: ReactNode }) {
  useLayoutEffect(() => {
    const mq = matchMedia("(prefers-color-scheme: dark)");
    const apply = (): void => applyTheme(mq.matches ? Theme.DARK : Theme.LIGHT, document.documentElement);
    apply();
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, []);
  return (
    <ThemeProvider theme={Theme.AUTO} passToPopups className="contents">
      {children}
    </ThemeProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <RingTheme>
        <App />
      </RingTheme>
    </BrowserRouter>
  </StrictMode>,
);
